<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Integration Work Orders to Edit"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Edit integration data for work orders."
      @on-submit="createIntegrationsWorkOrdersImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Integration Work Orders to Edit Template.xlsx"
              :file-provider="$importsAPI.getIntegrationsWorkOrdersTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'IntegrationsWorkOrdersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'integrations-work-orders-imports-add-modal',
    };
  },
  methods: {
    createIntegrationsWorkOrdersImport(data, handleCreate) {
      handleCreate(this.$importsAPI.integrationsWorkOrdersCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
